var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.363,
    height: 62.363,
    viewBox: "0 0 62.363 62.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_380",
    "data-name": "Groupe 380",
    transform: "translate(-399 -5228.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_701",
    "data-name": "Trac\\xE9 701",
    d: "M57.345,3.018H48.29V0H12.073V3.018H3.018A2.851,2.851,0,0,0,0,6.036V13.28A13.691,13.691,0,0,0,12.073,26.862v.3A18.153,18.153,0,0,0,26.258,44.97l-2.113,6.338H17.2a2.9,2.9,0,0,0-2.716,2.113l-2.415,6.942H48.29l-2.415-6.942a2.9,2.9,0,0,0-2.716-2.113H36.218L34.105,44.97A18.153,18.153,0,0,0,48.29,27.163v-.3A13.691,13.691,0,0,0,60.363,13.28V6.036a2.851,2.851,0,0,0-3.018-3.018M6.036,13.28V9.054h6.036V20.825A8.06,8.06,0,0,1,6.036,13.28m30.182,16.9-6.036-3.32-6.036,3.32,1.509-6.036-4.527-6.036h6.338l2.716-6.036L32.9,18.109h6.338l-4.527,6.036Zm18.109-16.9a7.787,7.787,0,0,1-6.036,7.545V9.054h6.036Z",
    transform: "translate(400 5229.963)",
    fill: "#d9fdf9",
    stroke: "#3ac1ae",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.783c6c9bbc14768e96ca5d85b6f3bdc5.svg";
export { ForwardRef as ReactComponent };